// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disclaimer[data-v-130bb026],.v-card__subtitle[data-v-130bb026]{text-align:center}.disclaimer[data-v-130bb026]{font-style:italic;width:60%;margin:auto}.right[data-v-130bb026]{text-align:right}", ""]);
// Exports
module.exports = exports;
